(() => {
  if (window.fmFamilyBound) return;
  window.fmFamilyBound = true;
  document.addEventListener('change', event => {
    const select = event.target.closest('[data-fm-config]');
    if (!select) return;
    const next = new URL(select.value, window.location.origin);
    const current = new URL(window.location.href);
    for (const key of ['preview_theme_id', '_fd', 'pb']) {
      if (current.searchParams.has(key)) next.searchParams.set(key, current.searchParams.get(key));
    }
    window.location.assign(next.href);
  });
  window.addEventListener('pageshow', () => {
    document.querySelectorAll('[data-fm-config]').forEach(select => {
      const selected = Array.from(select.options).find(option => option.defaultSelected);
      if (selected) select.value = selected.value;
    });
  });
})();
